module.exports = __webpack_public_path__ + "static/media/details-1-iphone.7ea92ec4.png";